export default __webpack_public_path__ + "media/call_to_action/ios_app_440-fc066a35.png";